module.exports = __webpack_public_path__ + "static/media/LK__EV charger_White.be4adc16.svg";